import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { createErrorReporterMiddleware } from '@mews/framework';
import { createJourneyTrackingMiddleware } from '@mews/framework/observability';

import { createErrorHandlerMiddleware } from './middlewares/createErrorHandlerMiddleware';

export const configureStore = ({
    initialState,
    configuredMiddlewares,
    contextWindow,
    apolloClient,
    appClockService,
    apiService,
    calendarService,
    environmentService,
    historyService,
    loggerService,
    pciProxyService,
    platformImageAssetLoader,
    trackingConsentsService,
    sentryReporterService,
    featureFlagService,
    moduleManager,
    newRelicReporterService,
    repositories,
    gainsightService,
    recaptchaService,
    setHtmlLanguage,
}: $TSFixMe) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const composeEnhancers = contextWindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? contextWindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
              serialize: {
                  options: {
                      undefined: true,
                  },
              },
          })
        : compose;

    const middlewares = [
        createErrorReporterMiddleware({ loggerService, sentryReporterService }),
        createErrorHandlerMiddleware({ loggerService, environmentService }),
        thunk.withExtraArgument({
            apolloClient,
            apiService,
            appClockService,
            calendarService,
            environmentService,
            historyService,
            loggerService,
            pciProxyService,
            platformImageAssetLoader,
            trackingConsentsService,
            featureFlagService,
            serviceRegistry: moduleManager.serviceRegistry,
            newRelicReporterService,
            repositories,
            gainsightService,
            recaptchaService,
            setHtmlLanguage,
        }),
        createJourneyTrackingMiddleware(),
        ...configuredMiddlewares,
    ];

    if (process.env.NODE_ENV === 'development' && __LOCALHOST__) {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const { createLogger } = require('redux-logger');
        const logger = createLogger({
            collapsed: true,
        });
        middlewares.push(logger);
    }

    return createStore(moduleManager.reduce, initialState, composeEnhancers(applyMiddleware(...middlewares)));
};
